var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnScrollTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90.842,
    height: 90.841,
    viewBox: "0 0 90.842 90.841",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#453878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#6154c7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1685.758 -3629.029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1731.179,3719.87a45.421,45.421,0,1,1,45.421-45.42A45.472,45.472,0,0,1,1731.179,3719.87Zm0-85.841a40.421,40.421,0,1,0,40.421,40.421A40.466,40.466,0,0,0,1731.179,3634.029Z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1746.315,3670.435h-9.77v28.524c0,1.722-1.77,3.108-3.956,3.108h-2.831c-2.174,0-3.945-1.386-3.945-3.108v-28.524h-9.77c-1.443,0-2.35-1.231-1.629-2.22l15.136-20.641a2.158,2.158,0,0,1,3.257,0l15.137,20.641C1748.665,3669.2,1747.758,3670.435,1746.315,3670.435Z",
    fill: "url(#b)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnScrollTop);
export default __webpack_public_path__ + "static/media/btn-scroll-top.0dcad6168c131b9ee4e8a5e6bce2811b.svg";
export { ForwardRef as ReactComponent };